export default "__VITE_ASSET__BYPWxLgM__"